import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { apiUrl } from "../constants/urls";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})

export class UsersService {
  constructor(private http: HttpClient) {}

  getAll(pageSize, pageNumber, searchText = "") {
    return this.http.get(
      `${apiUrl}/Users?pageSize=${pageSize}&pageNumber=${pageNumber}&searchText=${searchText}`
    );
  }

  get(id: string) {
    return this.http.get(`${apiUrl}/users/${id}`);
  }

  create(data) {
    return this.http.post(`${apiUrl}/users`, data);
  }

  update(data) : Observable<object>  {
    return this.http.put(`${apiUrl}/users`, data);
  }

  updateStatus(id: string): Observable<object> {
    return this.http.put(`${apiUrl}/users/enabledisable/${id}`, '');
  }
  
  delete(id: string) {
    return this.http.delete(`${apiUrl}/users/${id}`);
  }

  getCarrierPassword(id: string) {
    return this.http.get(`${apiUrl}/users/password/${id}`);
  }

  setCarrierPassword(id: string) {
    return this.http.post(`${apiUrl}/users/password/${id}`, '');
  }
}
